import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getNameKuesioner = createAsyncThunk("kuesioner/getNameKuesioner", 
async() => {
    try{
        let token = localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `/v1/questioner`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(error){
        console.error("Error fetching data:", error);
        throw error;
    }
});

export const createNameQuestioner = createAsyncThunk("kuesioner/createNameQuestioner", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/questioner', payload);
    return response.data;
});

export const updateNameQuestioner = createAsyncThunk("kuesioner/updateNameQuestioner", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('/v1/questioner', payload);
    return response.data;
});

export const deleteNameQuestioner = createAsyncThunk("kuesioner/deleteNameQuestioner", async(id) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.delete(`/v1/questioner/${id}`);
    return response.data;
});

export const getDetail = createAsyncThunk("kuesioner/getDetail", 
async(id) => {
    try{
        let token = localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `/v1/questioner_all/detail/${id}`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(error){
        console.error("Error fetching data:", error);
        throw error;
    }
});

export const createDetailQuestioner = createAsyncThunk("kuesioner/createDetailQuestioner", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/questioner_all/insert', payload);
    return response.data;
});

export const updateDetailQuestioner = createAsyncThunk("kuesioner/updateDetailQuestioner", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('/v1/questioner_all', payload);
    return response.data;
});

export const hasilQuestioner = createAsyncThunk("kuesioner/hasilQuestioner", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/questioner_result/all', payload);
    return response.data;
});



const initialState = {
    loading : false,
    dataName : [],
    dataDetail : [],
    dataHasil : []
}

const kuesionerSlice = createSlice({
    name:"kuesioner",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getNameKuesioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(getNameKuesioner.fulfilled, (state, action) => {
                state.dataName = action.payload;
                state.loading = false;
            })
            .addCase(getNameKuesioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(createNameQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(createNameQuestioner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createNameQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(updateNameQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateNameQuestioner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateNameQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(deleteNameQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteNameQuestioner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteNameQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
            
        builder
            .addCase(getDetail.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDetail.fulfilled, (state, action) => {
                state.dataDetail = action.payload;
                state.loading = false;
            })
            .addCase(getDetail.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(createDetailQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(createDetailQuestioner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createDetailQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(updateDetailQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateDetailQuestioner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateDetailQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(hasilQuestioner.pending, (state) => {
                state.loading = true;
            })
            .addCase(hasilQuestioner.fulfilled, (state, action) => {
                state.dataHasil = action.payload;
                state.loading = false;
            })
            .addCase(hasilQuestioner.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
    }
})

export const kuesionerSelector = (state) => state.kuesioner;
export default kuesionerSlice.reducer;